import {
  IStyleFunctionOrObject,
  Persona,
  PersonaSize,
  Spinner,
  StateBlock,
  StateBlockStyleProps,
  StateBlockStyles
} from "@bps/fluent-ui";
import { User } from "@stores/core/models/User.ts";
import { Contact } from "@stores/practice/models/Contact.ts";
import { UserFetcher } from "@ui-components/UserFetcher.tsx";

interface DischargeSummaryProviderProps {
  providerId: string;
  providerBusinessRole?: string;
}

export const DischargeSummaryProvider: React.FunctionComponent<
  DischargeSummaryProviderProps
> = ({ providerId, providerBusinessRole }) => {
  const getPersonaBadge = (person: Contact | User) => {
    const isContact = (contactOrUser: any): contactOrUser is Contact => {
      return !!(contactOrUser as Contact).type;
    };

    const profilePictureUrl = isContact(person)
      ? person.profilePictureUrl
      : undefined;

    return (
      <Persona
        text={person.name}
        id={person.id}
        imageUrl={profilePictureUrl}
        size={PersonaSize.size48}
        imageInitials={person.initials}
        styles={{
          details: {
            paddingRight: 0
          },
          root: {
            width: "100%"
          }
        }}
        onRenderPrimaryText={() => {
          let text = "";
          if (person) {
            text = isContact(person) ? person.nameWithTitle : person.fullName;
          }

          return <span>{text}</span>;
        }}
        onRenderSecondaryText={() => {
          return <>{providerBusinessRole}</>;
        }}
      />
    );
  };

  const stateBlockStyles: IStyleFunctionOrObject<
    StateBlockStyleProps,
    StateBlockStyles
  > = {
    root: {
      padding: "8px 16px"
    }
  };

  return (
    <StateBlock
      styles={stateBlockStyles}
      labelText=""
      descText={
        <UserFetcher
          refetchId={providerId}
          userId={providerId}
          fallback={<Spinner />}
        >
          {(user: User) => getPersonaBadge(user)}
        </UserFetcher>
      }
    />
  );
};
